import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/logout.svg'


const _withScopeId = n => (_pushScopeId("data-v-390a6bba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-header" }
const _hoisted_2 = { class: "order-title" }
const _hoisted_3 = {
  class: "title",
  "data-cy": "order-title"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "logout-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("ORDER.TITLE")) + " " + _toDisplayString(_ctx.orderSearchResult.order.originId), 1),
      _createElementVNode("div", {
        class: "logout",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logoutUser('logout-by-user', true)))
      }, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t("COMMON.LOGOUT")), 1)
      ])
    ]),
    _createVNode(_component_Button, {
      text: _ctx.t('ORDER.NEW_TICKET'),
      disabled: _ctx.newRmaDisabled,
      disabledReason: _ctx.newRmaDisabledReason,
      tooltip: true,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (
        _ctx.redirectToIfNotDisabled('NewTicket', {
          oid: _ctx.orderSearchResult.order.id
        })
      )),
      class: "router-btn",
      "data-cy": "create-new-ticket"
    }, null, 8, ["text", "disabled", "disabledReason"])
  ]))
}